/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { components } from 'react-select/dist/react-select.cjs.prod'


const Login = lazy(() => import('views/default/Login'));
const Instructions = lazy(() => import('views/default/Instructions'));
const Guidance=lazy(()=>import('views/default/Guidance'));
// const Fileinventary=lazy(()=> import('Reviewer/ReviewerArticle/Fileinventary'))



// const products = {
//   list: lazy(() => import('views/products/list/ProductsList')),
//   detail: lazy(() => import('views/products/detail/ProductsDetail')),
// };
// const orders = {
//   list: lazy(() => import('views/orders/list/OrdersList')),
//   detail: lazy(() => import('views/orders/detail/OrdersDetail')),
// };
// const customers = {
//   list: lazy(() => import('views/customers/list/CustomersList')),
//   detail: lazy(() => import('views/customers/detail/CustomersDetail')),
// };

// const storefront = {
//   home: lazy(() => import('views/storefront/home/Home')),
//   filters: lazy(() => import('views/storefront/filters/Filters')),
//   categories: lazy(() => import('views/storefront/categories/Categories')),
//   detail: lazy(() => import('views/storefront/detail/Detail')),
//   cart: lazy(() => import('views/storefront/cart/Cart')),
//   checkout: lazy(() => import('views/storefront/checkout/Checkout')),
//   invoice: lazy(() => import('views/storefront/invoice/Invoice')),
// };
// const shipping = lazy(() => import('views/shipping/Shipping'));
// const discount = lazy(() => import('views/discount/Discount'));

// const settings = {
//   home: lazy(() => import('views/settings/home/Home')),
//   general: lazy(() => import('views/settings/general/General')),
// };

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const DefaultroutesAndMenuItems = {
    mainMenuItems: [
        {
            path: DEFAULT_PATHS.APP,
            exact: true,
            redirect: true,
            to: `${appRoot}/login`,
        },
        {
            path: `${appRoot}/login`,
            component: Login,
            // label:"Login",
            // icon:"shop"
        },
        {
            path: `${appRoot}/instructions123`,
            component: Instructions,
            // label:"Login",
            // icon:"shop"
        },
        {
            path:`${appRoot}/guidance`,
            component:Guidance,
        },
    ],
    sidebarItems: [],
};





export default DefaultroutesAndMenuItems;
